import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Showcase } from './components/Showcase';
import { Pricing } from './components/Pricing';
import { Skills } from './components/Skills';
import { Integrations } from './components/Integrations';
import { ApiTeaser } from './components/ApiTeaser';
import { Testimonial } from './components/Testimonial';
import { Cta } from './components/Cta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cozy-bg font-sans text-cozy-text relative" data-id="element-0">
      {/* Global subtle grid background */}
      <div className="fixed inset-0 bg-grid-pattern opacity-50 pointer-events-none z-0" data-id="element-1" />

      <div className="relative z-10" data-id="element-2">
        <Nav data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <Features data-id="element-6" />
          <Showcase data-id="element-7" />
          <Pricing data-id="element-8" />
          <Skills data-id="element-9" />
          <Integrations data-id="element-10" />
          <ApiTeaser data-id="element-11" />
          <Testimonial data-id="element-12" />
          <Cta data-id="element-13" />
        </main>
        <Footer data-id="element-14" />
      </div>
    </div>;
}